import { useEffect, useState } from "react";

import type { Treatment } from "api/types/Treatment";

export const useSelectedTreatment = (treatments: Treatment[] | undefined, previousTreatmentId: number | null) => {
  const [selectedTreatment, setSelectedTreatment] = useState<Treatment>();

  useEffect(() => {
    if (!treatments) return;

    const previousTreatment = treatments.find(tm => tm.id === previousTreatmentId);
    const currentTreatment = treatments.find(tm => tm.is_current_treatment === true);
    setSelectedTreatment(previousTreatment || currentTreatment);
  }, [previousTreatmentId, treatments]);

  return selectedTreatment;
};
